// @flow
import classify from '@src/utils/typestyle';

import LinkPopup from '@components/popups/Link';
import * as SizeAndShapeContent from '@components/popups/content/SizeShapeOnRing';

import { linkBlueText } from '@src/styles/general';

const classes = classify({
  link: {
    color: linkBlueText,
    $nest: {
      '&:hover': {
        textDecoration: 'underline'
      }
    }
  },
  sampleImage: {
    marginTop: '12px',
    marginBottom: '13px',
    fontSize: '13px',
    lineHeight: '16px',
    textAlign: 'center',
    color: '#908e8e'
  }
});

type PropsType = {
  onToggleBandClick: () => void,
  color: string
};

export default function InARing(props: PropsType) {
  return (
    <div style={{ position: 'relative' }}>
      <p className={classes.sampleImage}>
        How a diamond of this{' '}
        <LinkPopup initialContent={SizeAndShapeContent}>
          <span className={classes.link}>size and shape</span>
        </LinkPopup>{' '}
        would appear on a 2mm{' '}
        <a
          href='javascript:void(0)'
          onClick={props.onToggleBandClick}
          title='change color'
          className={classes.link}
        >
          {props.color}
        </a>{' '}
        gold band.
      </p>
    </div>
  );
}
